import { IncorrectRecording, MissingRecording } from 'app/ErrorReporting/types';

export const TOGGLE_ALL = 'toggle all';
export const TOGGLE_ONE = 'toggle one';
export const UNSELECT_ALL = 'unselect all';

// recordingGid is the key, selected state is the boolean value
export type RecordingsState = { [index: string]: boolean };
export type RecordingsReducerState = {
  allRecordingsChecked: boolean;
  anyRecordingsChecked: boolean;
  recordings: RecordingsState;
};
export type RecordingReducerActionTypes = 'toggle all' | 'toggle one' | 'unselect all';
export type RecordingReducerAction = {
  type: RecordingReducerActionTypes;
  recordingGid?: string;
};

export const getRecordingReducerState = (
  recordings: IncorrectRecording[] | MissingRecording[] | undefined,
): RecordingsReducerState => {
  const recordingsMap: RecordingsState = {};
  recordings?.forEach((recordings) => {
    recordingsMap[recordings.recordingGid] = false;
  });
  return {
    allRecordingsChecked: false,
    anyRecordingsChecked: false,
    recordings: recordingsMap,
  };
};

const updateAllRecordingsWithOneValue = (state: RecordingsReducerState): RecordingsReducerState => {
  const newAllRecordingsChecked = !state.allRecordingsChecked;
  const newRecordings = { ...state.recordings };

  Object.keys(newRecordings).forEach((key) => {
    newRecordings[key] = newAllRecordingsChecked;
  });

  return {
    anyRecordingsChecked: newAllRecordingsChecked,
    allRecordingsChecked: newAllRecordingsChecked,
    recordings: newRecordings,
  };
};

const updateSingleRecording = (
  state: RecordingsReducerState,
  recordingGid: string,
): RecordingsReducerState => {
  const newRecordings = {
    ...state.recordings,
    [recordingGid]: !state.recordings[recordingGid],
  };

  const atleastOneRecordingNotChecked =
    Object.values(newRecordings).findIndex((newRecordingChecked) => !newRecordingChecked) >= 0;

  const atleastOneRecordingChecked = Object.values(newRecordings).findIndex((v) => v) >= 0;

  return {
    anyRecordingsChecked: atleastOneRecordingChecked,
    allRecordingsChecked: !atleastOneRecordingNotChecked,
    recordings: newRecordings,
  };
};

const updateAllRecordingsToBeUnselected = (
  state: RecordingsReducerState,
): RecordingsReducerState => {
  const newRecordings = { ...state.recordings };

  Object.keys(newRecordings).forEach((key) => {
    newRecordings[key] = false;
  });

  return {
    anyRecordingsChecked: false,
    allRecordingsChecked: false,
    recordings: newRecordings,
  };
};

const recordingReducer = (state: RecordingsReducerState, action: RecordingReducerAction) => {
  switch (action.type) {
    case 'toggle all':
      return updateAllRecordingsWithOneValue(state);
    case 'toggle one':
      return updateSingleRecording(state, action.recordingGid!);
    case 'unselect all':
      return updateAllRecordingsToBeUnselected(state);
  }
};

export default recordingReducer;
